export default "__VITE_ASSET__Du7MkLS2__"